<template> </template>
<script>
export default {
  name: 'Logout',
  mounted() {
    this.clearSession()
    
  },
  data() {
    return {}
  },
  methods: {
    clearSession() {
      localStorage.setItem('userType', 2)
      localStorage.setItem('status', 1)
      // localStorage.removeItem('attempts')
      // sessionStorage.removeItem('status')
      // localStorage.removeItem('tv')
      // localStorage.removeItem('power')
      // localStorage.removeItem('data')
      // localStorage.removeItem('airtime')
      // localStorage.removeItem('expire')
      // localStorage.removeItem('timestamp')
      // localStorage.removeItem('user')
      // localStorage.removeItem('email')
      // localStorage.removeItem('username')
      window.location.assign('/')
    }
  }
}
</script>
